<ng-container *ngIf="isUiSnippet; then uiSnippet; else content"></ng-container>

<ng-template #content>
  <ng-container *ngIf="hasTextCollapse(); else defaultContent">
    <app-text-collapse
      style="width: 100%"
      [content]="item.content"
      [maxLength]="getTextCollapseMaxLength()"
    ></app-text-collapse>
  </ng-container>
  <ng-template #defaultContent>
    <ng-container *ngIf="item.isHtmlContent; then quill; else innerContent"></ng-container>
  </ng-template>

  <ng-template #innerContent>
    <div [outerHTML]="innerContentHtml"></div>
  </ng-template>

  <ng-template #quill>
    <div class="ql-container ql-snow" style="border-width: 0" >
      <div [innerHTML]="item.content | safeHtml" [ngClass]="getLineClampClass()" class="ql-editor"></div>
    </div>
  </ng-template>

</ng-template>

<ng-template #uiSnippet>
  <div *ngIf="isCountSnippet; else uiSnippetRest">
    {{ snippetContent }}
  </div>
  <ng-template #uiSnippetRest>
    <!-- Wymiary mogą zawierać `<br>` (kilka wymiarów), więc renderujemy je jako HTML. -->
    <div *ngIf="isDimensionsSnippet; else storeSnippetTpl" [innerHTML]="snippetContent | safeHtml"></div>
    <ng-template #storeSnippetTpl>
      <div *ngIf="store$ | async as store; else snippetContentTpl">
        <p>{{ store | uiSnippet : item.content || "" }}</p>
      </div>
      <ng-template #snippetContentTpl>
        {{ snippetContent }}
      </ng-template>
    </ng-template>
  </ng-template>
</ng-template>
